export class AssistantError extends Error {}
